<template>
	<div class="announcement-overview">
		<div class="rs-o-surf-container rs-o-surf-module-section">
			<OverviewModuleTitle :name="name" />

			<SurfContentEmpty v-if="isEmptyAnim" />
			<div v-else class="rs-o-surf-anim-root" ref="animRootRef">
				<div class="overview-group">
					<SurfInlineTwoTextStyle1
						v-for="(item, index) in listData"
						:key="index"
						:item="formatForOverview(item)"
						@click="handlePreview(item)"
					/>
				</div>
				<OverviewModuleFooter @click="handleModuleMore" />
			</div>
		</div>
	</div>
</template>

<script setup>
import OverviewModuleTitle from '@rebuild/materials/shared/page_container/OverviewModuleTitle.vue';
import OverviewModuleFooter from '@rebuild/materials/shared/page_container/OverviewModuleFooter.vue';
import SurfContentEmpty from '@rebuild/materials/shared/common/surf/SurfContentEmpty.vue';
import SurfInlineTwoTextStyle1 from '@rebuild/materials/shared/common/surf/SurfInlineTwoTextStyle1.vue';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { contentFadeIn } from '@rebuild/materials/shared/page_container/animation/animationContext';
import { onMounted, ref, watch, computed } from 'vue';
import { useAnimationWorkflow } from '@rebuild/materials/shared/page_container/animation/useAnimationWorkflow';
import { useSurfAnnouncement } from '@rebuild/materials/shared/announcement/surf/useSurfAnnouncement';

const props = defineProps({
	name: {
		type: String,
		required: true
	},
	moduleId: {
		type: String,
		required: true
	},
	slideVisible: {
		type: Boolean,
		default: false
	}
});

const animRootRef = ref(null);
const { isEmptyAnim, ensureAnimation, markAnimReady, markContentVisible } = useAnimationWorkflow({
	createAnimation: () => {
		return contentFadeIn(animRootRef.value);
	}
});

onMounted(() => {
	ensureAnimation();
});
watch(() => props.slideVisible, markContentVisible);

const { announcementData, initConfig, loadAnnouncementData, formatForOverview, handlePreview, getFullTypeRange } =
	useSurfAnnouncement();

const listData = computed(() => {
	return announcementData.value;
});

const maxDisplayCount = 4;
const loadData = async () => {
	await initConfig();
	await loadAnnouncementData({
		pageStart: 0,
		pageNum: maxDisplayCount,
		classificationIds: getFullTypeRange()
	});
	const hasData = announcementData.value.length > 0;
	markAnimReady(hasData);
};

onMounted(() => {
	loadData();
});

const { viewPageInSurf } = useNavigation();
const handleModuleMore = () => {
	viewPageInSurf({
		module: { moduleId: props.moduleId }
	});
};
</script>

<style lang="less" scoped>
.announcement-overview {
	.overview-group {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}
}
</style>
